import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import Quill from 'quill';
@Component({
  selector: 'app-quill-editor',
  templateUrl: './quill-editor.component.html',
  styleUrls: ['./quill-editor.component.css']
})
export class QuillEditorComponent {
  @Input() control!: FormControl; // Receive FormControl from parent
  @Output() submit = new EventEmitter<string>();


  @ViewChild('editorContainer', { static: false }) editorContainer!: ElementRef;
  quillEditor: any;
  toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['link', 'image', 'video', 'formula'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean']                                         // remove formatting button
  ];
  ngOnInit(): void {
    if (this.control) {
      this.control.valueChanges.subscribe(value => {
        if (this.quillEditor && value !== this.quillEditor.root.innerHTML) {
          this.quillEditor.root.innerHTML = value; // Update editor when FormControl value changes
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.initializeQuillEditor();
    setTimeout(() => {
      if (this.control?.value) {
        this.quillEditor.root.innerHTML = this.control.value;
      }
      if (this.quillEditor && this.quillEditor.root && this.quillEditor.root.style) {
        this.quillEditor.root.style.height = '261px';
      }

      this.quillEditor?.update();
    });
  }

  initializeQuillEditor(): void {
    this.quillEditor = new Quill(this.editorContainer.nativeElement, {
      theme: 'snow', // Choose 'snow' or 'bubble' theme
      modules: {
        toolbar: this.toolbarOptions
      }
    });

    this.quillEditor.on('text-change', () => {
      const content = this.quillEditor.root.innerHTML;
      this.control.setValue(content, { emitEvent: false }); // Update FormControl without triggering infinite loop
    });
  }

  onSubmit(): void {
    this.submit.emit(this.control.value);
  }

  updateEditorSize(): void {
  if (this.quillEditor) {
    this.quillEditor.update(); // forces Quill to recalc width/height
  }
}

}
